module.exports = __webpack_public_path__ + "static/media/24.c265d264.jpg";